import { makeAutoObservable } from 'mobx'

import type { components } from '../constants/schema'

import { HttpReq } from '../utils'

import RootStore from './root'

import * as ChannelService from '@channel.io/channel-web-sdk-loader'
import { format } from 'libphonenumber-js'
import { abrCompleteIdentification } from '../utils/abr'

export class IdentityStore {
  rootStore: RootStore

  async getIdentityVerificationId(): Promise<components['schemas']['ResIdentityVerificationId']> {
    const identityVerificationId = await HttpReq<components['schemas']['ResIdentityVerificationId']>({
      method: 'GET',
      url: '/identification/identityVerificationId',
    })
    return identityVerificationId || null
  }

  async identify(data: components['schemas']['ReqQueryIdentication']) {
    try {
      const response = await HttpReq<components['schemas']['IdentificationDto']>({
        method: 'POST',
        url: '/identification/identify',
        data,
      })
      const atPorfile: Record<string, any> = {}

      if (response?.danalPhoneNumber) atPorfile.mobileNumber = format(response.danalPhoneNumber, 'KR', 'E.164')
      ChannelService.updateUser({ language: 'ko', profile: atPorfile })

      abrCompleteIdentification()
      ChannelService.track('complete_identification')

      return response
    } catch (error) {
      return error
    }
  }

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore
    makeAutoObservable(this)
  }
}
